"use client";

import { c as _c } from "react/compiler-runtime";
import { useCurrentRefinements } from "react-instantsearch";
import type { PlpFilterGroupConfig } from "@/lib/contentful/filterGroups";

// Returns true when the group should render. Unconditional groups always do;
// conditional groups when the parent's active value equals the trigger. "Active"
// means either a current refinement OR a route-level baked attribute (e.g.
// /stickers bakes `productType:Stickers` via Configure — useCurrentRefinements
// won't see it, so the bakedAttributes map carries it through).
export function useConditionalGroupVisible(group, bakedAttributes) {
  const $ = _c(7);
  const parentSlug = group.conditionalParentSlug;
  const trigger = group.conditionalTriggerAttributeKey;
  let t0;
  if ($[0] !== parentSlug) {
    t0 = {
      includedAttributes: parentSlug ? [parentSlug] : []
    };
    $[0] = parentSlug;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    items
  } = useCurrentRefinements(t0);
  if (!parentSlug || !trigger) {
    return true;
  }
  if (bakedAttributes?.[parentSlug] === trigger) {
    return true;
  }
  const parentItem = items[0];
  if (!parentItem) {
    return false;
  }
  let t1;
  if ($[2] !== parentItem.refinements || $[3] !== trigger) {
    let t2;
    if ($[5] !== trigger) {
      t2 = refinement => String(refinement.value) === trigger;
      $[5] = trigger;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = parentItem.refinements.some(t2);
    $[2] = parentItem.refinements;
    $[3] = trigger;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}